module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "abs-pa"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s6"
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.cognome,
      "prop": "prcognome"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.$abs.row.prcognome),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "prcognome", $$v)
      },
      expression: "$abs.row.prcognome"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col s6"
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.nome,
      "prop": "prnome"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.$abs.row.prnome),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "prnome", $$v)
      },
      expression: "$abs.row.prnome"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s6"
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.email,
      "prop": "premail"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.$abs.row.premail),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "premail", $$v)
      },
      expression: "$abs.row.premail"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col s6"
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.cellulare
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.$abs.row.prcellulare),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "prcellulare", $$v)
      },
      expression: "$abs.row.prcellulare"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col s12 m10 offset-m2"
  }, [_c('h4', {
    staticClass: "yo-color-secondary"
  }, [_vm._v(_vm._s(_vm.$teras.lang.privacyTitle))]), _vm._v(" "), (_vm.$teras.language == 'it') ? _c('div', [_vm._v("\n  Si prega di prendere visione dell'Informativa sul Trattamento dei Dati "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": 'https://bvent.biomedia.net/gdpr/privacy-ABSTRACT' + (_vm.$teras.evento.id == 136 ? '-' + _vm.$teras.evento.id : '') + '.pdf'
    }
  }, [_vm._v("cliccando qui")])]) : _vm._e(), _vm._v(" "), (_vm.$teras.language == 'en') ? _c('div', [_vm._v("\n  Please "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://bvent.biomedia.net/gdpr/privacy-ABSTRACT-en.pdf"
    }
  }, [_vm._v("view")]), _vm._v(" Privacy Policy\n  ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-128a0fdf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Abs-presentatore.vue
// module id = 599
// module chunks = 2